export default {
  newWindow: 'Abre numa janela nova',
}
